import React, { useRef, useCallback, useState, useEffect } from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import { AuthState } from 'store/ducks/auth';
import * as S from './styles';
import { MainContainer } from 'components/shared';

export const CheckFretes: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const { data } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.auth
  );

  const handleClick = useCallback(() => {
    if (ref.current) {
      if (window.document.fullscreenElement) {
        if (window.document.exitFullscreen) {
          window.document.exitFullscreen();
        }
      } else {
        ref.current.requestFullscreen();
      }
    }
  }, []);

  const handleKeyDown = useCallback(() => {
    setIsFullscreen((v) => !v);
  }, []);

  const getUrl = useCallback(() => {
    if (data) {
      if (data.rootCarrier) {
        return `https://analytics.zoho.com/open-view/1432280000158011139/ebbe416d0b088415c94d481fb42f55ad?ZOHO_CRITERIA_CARRIER=${data.rootCarrier}`;
      } else {
        return 'https://analytics.zoho.com/open-view/1432280000158011139/ebbe416d0b088415c94d481fb42f55ad';
      }
    }
    return '';
  }, [data]);

  useEffect(() => {
    if (window.document) {
      window.document.addEventListener('fullscreenchange', handleKeyDown);
    }

    return () => {
      window.document.removeEventListener('fullscreenchange', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <MainContainer>
      <S.Container ref={ref}>
        <S.Button onClick={handleClick}>
          {isFullscreen ? <S.IconExitFullscreen /> : <S.IconFullscreen />}
        </S.Button>
        <S.Iframe frameBorder={0} width="100%" height="100%" src={getUrl()} />
      </S.Container>
    </MainContainer>
  );
};
